import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import api from '../services/api';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('🌐 API URL:', api.defaults.baseURL);
        try {
            const response = await api.post('/token/', { username, password });

            //  ZAPISZ DO localStorage
            if (response.data.access && response.data.refresh) {
                localStorage.setItem('access_token', response.data.access);
                localStorage.setItem('refresh_token', response.data.refresh);

            } else {
                console.error('❌ Brak tokenów w odpowiedzi');
            }


            window.location.href = '/';
        } catch (err) {
            console.error('Login error:', err);
            setError('Nieprawidłowe dane logowania');
        }
    };

    return (
        <Container className="d-flex vh-100 align-items-center justify-content-center">
            <Row className="w-100">
                <Col md={6} lg={4} className="mx-auto">
                    <Card className="shadow">
                        <Card.Body className="text-center">
                            <img
                                src={logo}
                                alt="LMS Logo"
                                style={{
                                    height: '60px',
                                    width: '160px',
                                    marginRight: '12px',
                                    backgroundColor: '#ffffff',
                                }}></img>
                            <h4 className="text-center mb-4">Logowanie</h4>

                            {error && <Alert variant="danger">{error}</Alert>}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nazwa użytkownika</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Wprowadź nazwę użytkownika"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Hasło</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Wprowadź hasło"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit" className="w-100">
                                    Zaloguj się
                                </Button>
                                <div className="text-center mt-3">
                                    <small className="text-muted">
                                        Nie masz konta?{' '}
                                        <Link to="/register" className="text-decoration-none">
                                            Zarejestruj się
                                        </Link>
                                    </small>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;